import type { IconSvgObject } from './types';

const StampIcon: IconSvgObject = [
  ["path", { d: "M5 18.5C5 17.3954 5.89543 16.5 7 16.5H17C18.1046 16.5 19 17.3954 19 18.5V21.5H5V18.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 13H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 16L9.89543 11.227C9.95928 10.4564 9.53736 9.74525 9.02107 9.16951C8.38617 8.46149 8 7.52584 8 6.5C8 4.29086 9.79086 2.5 12 2.5C14.2091 2.5 16 4.29086 16 6.5C16 7.52584 15.6138 8.46149 14.9789 9.16951C14.4626 9.74525 14.0407 10.4564 14.1046 11.227L14.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default StampIcon;
